import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../data-access/models/user.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface NewUser {
  nombre: string;
  email: string;
  telefono: string;
  exten: string;
  job_title_id: number;
  responsable: number | null;
}

@Component({
  selector: 'app-modal-create-user',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-create-user.component.html'
})
export class ModalCreateUserComponent {
  @Input() isOpen = false;
  @Input() responsables: User[] = [];
  @Output() create = new EventEmitter<NewUser>();
  @Output() cancel = new EventEmitter<void>();

  user: NewUser = {
    nombre: '',
    email: '',
    telefono: '',
    exten: '',
    job_title_id: 1,
    responsable: null
  };

  error = '';
  isResponsable = true;

  get responsablesFiltrados(): User[] {
    return this.responsables.filter(r => r.job_title_id === this.user.job_title_id);
  }

  onAgenteChange() {
    // Si el responsable seleccionado no es válido para el agente, lo quitamos
    if (
      this.user.responsable !== null &&
      !this.responsablesFiltrados.some(r => r.id === this.user.responsable)
    ) {
      this.user.responsable = null;
    }
  }

  onCreate() {
    if (!this.user.nombre || !this.user.email || !this.user.telefono) {
      this.error = 'Todos los campos son obligatorios.';
      return;
    }
    if (!this.isResponsable && this.user.responsable === null) {
      this.error = 'Debes seleccionar un responsable.';
      return;
    }
    this.error = '';
    this.create.emit({ ...this.user });
    this.reset();
  }

  onCancel() {
    this.cancel.emit();
    this.reset();
  }

  reset() {
    this.user = {
      nombre: '',
      email: '',
      telefono: '',
      exten: '',
      job_title_id: 1,
      responsable: null
    };
    this.error = '';
    this.isResponsable = true;
  }
}
